var buttonFilterShow = document.querySelector('.b-filter-show');
var slInfoContent = document.querySelector('.b-filter-wrapper');

function classToggle() {
    buttonFilterShow.classList.toggle('show');
    slInfoContent.classList.toggle('show');
}

if(buttonFilterShow){
    buttonFilterShow.addEventListener('click', classToggle);
}


// WEBPACK FOOTER //
// ./src/js/pages/event-list/show-filter.js